import {createContext, useEffect, useReducer} from "react";

export const AuthContext = createContext();

export const localStoreKeys = {
    user: "dataUser"
}

// Type to events
const TYPE_AUTH = {
    login: 'logIn',
    logout: 'logOut',
    isMobile: 'isMobile',
}

// Values init to project
const INITIAL_STATE = {
    logged: false,
    dataUser: null,
    isMobile: window.innerWidth <=768
}

// Value init to context
const contextInitState = () =>{
    let oldDataUser = JSON.parse(localStorage.getItem(localStoreKeys.user));
    return {
        logged: !!oldDataUser,
        dataUser: !!oldDataUser ? oldDataUser:null,
        isMobile: window.innerWidth <=768
    }
}

// function to return value context
const switchValueContext = (state, action) =>{
    switch (action.type) {
        case TYPE_AUTH.login:
            return {
                logged: true,
                dataUser: action.dataUser,
                isMobile: window.innerWidth <=768
            }
        case TYPE_AUTH.logout:
            return INITIAL_STATE;

        case TYPE_AUTH.isMobile:

            return{
                ...state,
                isMobile: action.isMobile
            }

        default:
            return state;
    }
}

export function AuthComponent({children}){

    const [ logUser, setLogUser ] = useReducer(switchValueContext, INITIAL_STATE, contextInitState);

    useEffect(() => {

        const verificarTamanioPantalla = () =>{

            let action = {
                type: TYPE_AUTH.isMobile,
                isMobile: window.innerWidth <=768,
            }
            setLogUser(action);
        }

        // Agrega un event listener para seguir verificando cuando cambie el tamaño de la pantalla
        window.addEventListener('resize', verificarTamanioPantalla);

        // Limpia el event listener cuando el componente se desmonta
        return () => {
          window.removeEventListener('resize', verificarTamanioPantalla);
        };
    }, []);

    // function to logIn user
    const onLoginUser = (dataUser) =>{

        let action = {
            type: TYPE_AUTH.login,
            dataUser: dataUser,
        };
        localStorage.setItem(localStoreKeys.user, JSON.stringify(action.dataUser));

        setLogUser(action);

    }

    //function to delete keys and close session
    const oncloseLogIn = () =>{
        localStorage.removeItem(localStoreKeys.user);
        setLogUser({ type: TYPE_AUTH.logout});
    }

    return(
        <AuthContext.Provider value={{
                  ...logUser,
                handlingLogInUser: onLoginUser,
                handlingCloseSession: oncloseLogIn,
            }}>
            {children}
        </AuthContext.Provider>
    );

}